<script setup lang="ts">
import { ModalsContainer } from 'vue-final-modal';
import BottomSheetsContainer from '@components/base/mr-modal/BottomSheetsContainer.vue';
</script>

<template>
    <div>
        <div id="portal-title" class="title" />
        <ModalsContainer />
        <BottomSheetsContainer />
        <slot />
    </div>
</template>
<style scoped lang="scss">
.title {
    display: none;
}
:deep(.container-wrapper) {
    background: white !important;
}

:deep(h1) {
    display: none;
}

:deep(h2),
:deep(p),
:deep(ul) {
    font-size: 12px !important;
    color: usePalette($p-gray, $p-700) !important;
}

:deep(.container-wrapper) {
    padding: 0 !important;
}

:deep(iframe) {
    display: none;
}

:deep(a) {
    color: usePalette($p-gray, $p-700);
    pointer-events: none;
}

:deep(#pane4) {
    display: none !important;
}

:deep(.v--modal-overlay) {
    z-index: 1000 !important;
}
</style>
